import { VerticalTabs } from "@components/VerticalTabs";
import {
  matchPath,
  Navigate,
  useLocation,
  useNavigate
} from "react-router-dom";

import { Stack, useTheme } from "@bps/fluent-ui";
import { SystemBhTabs } from "./system-bh-tabs.constants";

export const SystemBhSections: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();

  const onSectionChange = (nextId: string) => {
    navigate(nextId);
  };

  const match = matchPath("/system/bh/:selectedTab", location.pathname);
  const selectedTab = match?.params?.selectedTab;

  if (!selectedTab) {
    return <Navigate to={SystemBhTabs.Operations.Banner.id} replace />;
  }

  return (
    <Stack
      tokens={{
        childrenGap: theme.spacing.m
      }}
    >
      <VerticalTabs
        title="Operations"
        tabs={Object.values(SystemBhTabs.Operations)}
        selectedTab={selectedTab}
        onSelectedTabChange={onSectionChange}
      />
    </Stack>
  );
};
